import { clearDraft, loadDraft, saveDraft } from './answerDraft';

/**
 * Черновик эссе IELTS Writing на устройстве (02.10.2026, решение владельца к сборке 1.1.1).
 *
 * ⚠️ ЗАЧЕМ. Текст эссе жил только в памяти экрана: «К заданиям», «назад» (жест на iPhone, кнопка на Android),
 * перезапуск приложения — и получасовая работа пропадала без вопроса. У Reading и Listening черновик ответов есть
 * с 07.09.2026 (`lib/answerDraft.ts`), у Writing его не было.
 *
 * Правила — те же: `localStorage`, 14 дней, стирается после принятой сдачи. Ключ — с учёткой: на общем телефоне
 * чужое эссе не должно открыться следующему ученику.
 */

export function writingDraftKey(userId: string | undefined, taskId: string): string {
  return `writing:${userId ?? 'anon'}:${taskId}`;
}

export function loadWritingDraft(key: string): string {
  const text = loadDraft<string>(key);
  return typeof text === 'string' ? text : '';
}

/** Пустой текст черновиком не считается: стёр всё — черновика нет. */
export function saveWritingDraft(key: string, text: string): void {
  if (text === '') clearDraft(key);
  else saveDraft(key, text);
}

export function clearWritingDraft(key: string): void {
  clearDraft(key);
}
